'use strict';

import {Component, Input,OnDestroy} from '@angular/core';

@Component({
    selector: 'spinner',
    template: require('./spinner.component.html')
})
export class SpinnerComponent implements OnDestroy  {
   
    private showSpinner: boolean = false;
    private size: string = '';

    @Input()
    public delay: number = 300;

    @Input()
    public set isRunning(value: boolean) {
      
            this.showSpinner = value;
          
    }

ngOnDestroy(): any {
        
    }
    

   
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/helper-components/spinner.component.ts